import React from 'react';
import { Box, Paper, Stack, Typography } from '@mui/material';
import DonutLargeRoundedIcon from '@mui/icons-material/DonutLargeRounded';
import { DashboardSectionTitle } from './DashboardSectionTitle';
import { formatKilos, formatPercent } from '../../utils/flujoCalculations';

export const FlowBreakdownCard = ({ title, items, total }) => {
  const legendItems = items.find((item) => item.segments?.length)?.segments || [];

  return (
    <Paper
      elevation={0}
      sx={{
        p: 2,
        border: '1px solid',
        borderColor: 'divider',
        borderRadius: 2,
        height: '100%',
      }}
    >
      <Stack
        direction="row"
        spacing={2}
        sx={{
          alignItems: 'center',
          justifyContent: 'space-between',
          flexWrap: 'wrap',
          gap: 1,
          mb: 2,
        }}
      >
        <DashboardSectionTitle icon={<DonutLargeRoundedIcon />}>
          {title}
        </DashboardSectionTitle>

        {legendItems.length > 0 && (
          <Stack direction="row" spacing={1.5} sx={{ flexWrap: 'wrap', justifyContent: 'flex-end', gap: 1 }}>
            {legendItems.map((segment) => (
              <Stack key={segment.label} direction="row" spacing={0.6} sx={{ alignItems: 'center' }}>
                <Box
                  sx={{
                    width: 8,
                    height: 8,
                    borderRadius: '50%',
                    bgcolor: segment.color,
                    flex: '0 0 auto',
                  }}
                />
                <Typography sx={{ color: 'text.secondary', fontSize: 12, fontWeight: 700 }}>
                  {segment.label}
                </Typography>
              </Stack>
            ))}
          </Stack>
        )}
      </Stack>

      <Stack spacing={1.5}>
        {items.map((item) => {
          const percent = total > 0 ? (item.value * 100) / total : 0;

          return (
            <Box key={item.label}>
              <Stack direction="row" sx={{ justifyContent: 'space-between', gap: 2, mb: 0.75 }}>
                <Typography sx={{ fontSize: 14, fontWeight: 800 }}>{item.label}</Typography>
                <Stack sx={{ alignItems: 'flex-end', minWidth: 0 }}>

                  {item.segments?.length && (
                    <Stack
                      direction="row"
                      spacing={1}
                      sx={{ flexWrap: 'wrap', justifyContent: 'flex-end', gap: 0.75 }}
                    >
                      {/* {item.segments.map((segment) => {
                        const segmentPercent = total > 0 ? (segment.value * 100) / total : 0;

                        return (
                          <Stack
                            key={segment.label}
                            direction="row"
                            spacing={0.5}
                            sx={{ alignItems: 'center' }}
                          >
                            <Box
                              sx={{
                                width: 7,
                                height: 7,
                                borderRadius: '50%',
                                bgcolor: segment.color,
                                flex: '0 0 auto',
                              }}
                            />
                            <Typography sx={{ fontSize: 12, color: 'text.secondary' }}>
                              {formatKilos(segment.value)} kg - {formatPercent(segmentPercent)} %
                            </Typography>
                          </Stack>
                        );
                      })} */}
                      <Typography sx={{ fontSize: 13, color: 'text.secondary' }}>
                        {formatKilos(item.value)} kg - {formatPercent(percent)} %
                      </Typography>
                    </Stack>
                  )}
                </Stack>
              </Stack>
              <Box
                sx={{
                  height: 8,
                  borderRadius: 1,
                  bgcolor: '#e5e7eb',
                  display: 'flex',
                  overflow: 'hidden',
                }}
              >
                {item.segments?.length
                  ? item.segments.map((segment) => (
                    <Box
                      key={segment.label}
                      sx={{
                        width: `${total > 0 ? (segment.value * 100) / total : 0}%`,
                        bgcolor: segment.color,
                      }}
                    />
                  ))
                  : (
                    <Box
                      sx={{
                        width: `${Math.min(percent, 100)}%`,
                        bgcolor: item.color || 'primary.main',
                      }}
                    />
                  )}
              </Box>
            </Box>
          );
        })}
      </Stack>
    </Paper>
  );
};
